import { createContext, FC, useContext, useState } from 'react'
import { SnackbarOrigin } from '@mui/material'

interface AlertContextTypes {
  text: string
  type: string
  setAlert: (text: string, type: string, anchorPosition: SnackbarOrigin) => void
  open: boolean
  anchorPosition: SnackbarOrigin
}

const ALERT_TIME = 5000

const AlertContext = createContext<AlertContextTypes | null>(null)

const AlertProvider: FC = ({ children }) => {
  const [text, setText] = useState<string>('')
  const [type, setType] = useState<string>('')
  const [open, setOpen] = useState(false)
  const [anchorPosition, setAnchorPosition] = useState<SnackbarOrigin>({
    vertical: 'bottom',
    horizontal: 'right',
  })
  // const [position, setPosition] = useState()
  const setAlert = (
    text: string,
    type: string,
    anchorPosition: SnackbarOrigin
  ) => {
    setText(text)
    setType(type)
    setAnchorPosition(anchorPosition)
    setOpen(true)

    setTimeout(() => {
      setOpen(false)
    }, ALERT_TIME)
  }

  return (
    <AlertContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        open,
        text,
        type,
        setAlert,
        anchorPosition,
      }}>
      {children}
    </AlertContext.Provider>
  )
}

export const useAlert = () => useContext(AlertContext) as AlertContextTypes

export default AlertProvider
